var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('entity-dotted-select');
import { breakpoints, theme } from '@shapeable/theme';
import { EntitySelect } from './entity-select';
import { DottedChevronDownIconGlyph } from '@shapeable/icons';
export var EntityDottedSelectDefaultProps = {};
// -------- Styles -------->
var clsSelect = classNames('entity-select');
var SelectStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n\n    .", " {\n      display: none;\n    }\n\n    .", " {\n      margin-top: 0;\n    }\n\n    .", " {\n      border: none;\n      min-height: 66px;\n    }\n\n    .", " {\n      align-items: flex-start;\n      margin-top: ", ";\n    }\n\n    .", " {\n      background: none;\n      border: none;\n    }\n\n    .", " {\n      color: ", ";\n      text-transform: uppercase;\n      font-weight: 400;\n      padding-left: 4px;\n      font-size: ", ";\n    }\n\n    .", " {\n      margin-left: 4px;\n      margin-right: 0;\n    }\n\n    ", "\n    \n\n  "], ["\n    font-size: ", ";\n\n    .", " {\n      display: none;\n    }\n\n    .", " {\n      margin-top: 0;\n    }\n\n    .", " {\n      border: none;\n      min-height: 66px;\n    }\n\n    .", " {\n      align-items: flex-start;\n      margin-top: ", ";\n    }\n\n    .", " {\n      background: none;\n      border: none;\n    }\n\n    .", " {\n      color: ", ";\n      text-transform: uppercase;\n      font-weight: 400;\n      padding-left: 4px;\n      font-size: ", ";\n    }\n\n    .", " {\n      margin-left: 4px;\n      margin-right: 0;\n    }\n\n    ", "\n    \n\n  "])), theme.FONT_SIZE(14), clsSelect.sub('indicator-separator'), clsSelect.sub('clear-indicator'), clsSelect.sub('control'), clsSelect.sub('indicators'), theme.UNIT(6), clsSelect.sub('multi-value'), clsSelect.sub('placeholder'), theme.COLOR('secondary'), theme.FONT_SIZE(13), clsSelect.sub('multi-value__remove'), function (props) {
    return props.hasError && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .", " {\n        border-color: red;\n      }\n    "], ["\n      .", " {\n        border-color: red;\n      }\n    "])), clsSelect.sub('control'));
  })
});
var IndicatorStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 28px;\n    margin: 0 16px;\n    ", ";\n  "], ["\n    width: 28px;\n    margin: 0 16px;\n    ", ";\n  "])), theme.FILL('secondary'))
});
// -------- Components -------->
var My = {
  Select: styled(EntitySelect)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  Indicator: styled(DottedChevronDownIconGlyph)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IndicatorStyles)
};
export var EntityDottedSelect = function (props) {
  return React.createElement(My.Select, __assign({}, props, {
    className: cls.name(props.className),
    isClearable: false,
    showSearchIcon: false,
    components: {
      DropdownIndicator: My.Indicator
    }
  }));
};
EntityDottedSelect.defaultProps = EntityDottedSelectDefaultProps;
EntityDottedSelect.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;